import React from 'react';
import './index.scss';
const ShareLoading = () => {
	let counter = 0;
//	let times = setInterval(function() {
//	  if (counter === 5) { 
//	    counter = 0; 
//	  }
//	  changeImage(counter);
//	  counter ++;
//	}, 1500);
//	function changeImage(counter) {
//	  let images = [
//	    '<i class="loader-icon loader-camera"></i>',
//	    '<i class="loader-icon loader-shutter"></i>',
//	    '<i class="loader-icon loader-cloud"></i>',
//	    '<i class="loader-icon loader-share"></i>',
//	    '<i class="loader-icon loader-photo"></i>'
//	  ];
//	  document.querySelector(".loader-image").innerHTML = images[counter];
//	}
//	function destroy() {
//		clearInterval(times);
//		times = null;
//	}
//	useEffect(() => {
//  return destroy;
//}, []);
	return (
		<div className="loader">
		  <div className="loader-image">
		    <i className="loader-icon loader-photo"></i>
		  </div>
		  <span className="loader-tips">正在为您生成分享图</span>
		</div>
	);
};
export { ShareLoading };
